// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IndexShow[data-v-f1ce62de]{width:100vw;position:fixed}.IndexShow>.GeneralToolbar[data-v-f1ce62de]{position:absolute;top:0}.IndexShow>.MenuInterface[data-v-f1ce62de]{position:absolute;bottom:10px;left:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
